<template>
	<CookieInformationBlocker
		class="c-cookie-information-blocker-custom"
		v-bind="{ ...$props, wrapper: 'div' }"
	>
		<template #default>
			<slot></slot>
		</template>

		<template #blocker="{ requiredCategories, cookieInformation }">
			<div
				:class="[
					'w-full bg-gray-light text-text overflow-hidden',
					'px-md/h pt-md/v pb-lg/v',
					{
						invisible: !cookieInformationReady,
					},
				]"
			>
				<BaseH2 class="text-red mb-2xs/v">
					<SvgIconWarning
						class="inline-block text-text baseline relative"
						style="width: 1em; aspect-ratio: 62 /56; top: -0.1em"
					/>
					<span v-text="'Indhold Blokeret'"></span>
				</BaseH2>

				<div class="s-rich-text">
					<p>
						Dette element kan ikke vises, da du ikke har givet
						accept til følgende typer af cookies:
					</p>

					<ul>
						<li
							v-for="consent in requiredCategories.filter(
								(e) => !e.consentGiven
							)"
							:key="`consent-${consent.name}`"
							v-text="
								{
									statistic: 'Statistiske',
									functional: 'Funktionelle',
									marketing: 'Marketing',
								}[consent.name]
							"
						></li>
					</ul>

					<p>
						Du kan ændre dine indstillinger ved at klikke på knappen
						herunder.
					</p>
				</div>

				<BaseButton
					class="bg-red hover:bg-red-90 mt-xs/v"
					@click="cookieInformation.show"
					v-text="'Åben cookie-indstillinger'"
				/>
			</div>
		</template>
	</CookieInformationBlocker>
</template>

<script>
import { cookieInformationData } from '~/components/shared/CookieInformation';
import CookieInformationBlocker from '~/components/shared/CookieInformationBlocker';
import SvgIconWarning from '~/assets/svgs/icon-warning.svg?inline';

export default {
	name: 'CookieInformationBlockerCustom',

	components: { CookieInformationBlocker, SvgIconWarning },

	props: {
		...CookieInformationBlocker.props,
		// debugShowBlocker: {
		// 	type: Boolean,
		// 	default: true,
		// },
	},

	data() {
		return {
			mountReady: false,
		};
	},

	computed: {
		cookieInformationReady() {
			return (
				(this.mountReady && cookieInformationData.consentRef) ||
				this.categories.length === 0
			);
		},
	},

	beforeMount() {
		this.mountReady = true;
	},
};
</script>
